import type { FC } from 'react';
import { ExclamationIcon, QuestionMarkCircleIcon } from '@heroicons/react/outline';
import clsx from 'clsx';

const ICON_STYLES = {
  valid: {
    icon: QuestionMarkCircleIcon,
    bgColor: 'bg-success-50',
    iconColor: 'text-success-600',
  },
  warning: {
    icon: ExclamationIcon,
    bgColor: 'bg-warning-50',
    iconColor: 'text-warning-600',
  },
  danger: {
    icon: ExclamationIcon,
    bgColor: 'bg-red-50',
    iconColor: 'text-red-600',
  },
} as const;

export type ModalIconVariant = keyof typeof ICON_STYLES;

export const ModalIcon: FC<{ variant: ModalIconVariant }> = ({ variant }) => {
  const style = ICON_STYLES[variant];

  return (
    <div
      className={clsx(
        'mx-auto flex h-12 w-12 shrink-0 items-center justify-center rounded-full sm:mx-0 sm:h-10 sm:w-10',
        style.bgColor,
      )}
      data-testid="modal-icon"
      data-variant={variant}
    >
      <style.icon className={clsx('h-6 w-6', style.iconColor)} aria-hidden="true" />
    </div>
  );
};
